import dayjs from 'dayjs'
import { arrayOfN } from './utils'

const NUM_GRAD_YEARS_TO_DISPLAY = 7

export const getGradYearOptions = (): number[] => {
  const thisYear = dayjs().year()
  return arrayOfN(NUM_GRAD_YEARS_TO_DISPLAY).map((i: number) => thisYear + i)
}
